__turbopack_context__.v({
  "loop": "Rzl_Ca_loop",
  "multi-slider-active-dots": "Rzl_Ca_multi-slider-active-dots",
  "multi-slider-carousel-container": "Rzl_Ca_multi-slider-carousel-container",
  "multi-slider-container": "Rzl_Ca_multi-slider-container",
  "multi-slider-indicator-dots": "Rzl_Ca_multi-slider-indicator-dots",
  "multi-slider-item": "Rzl_Ca_multi-slider-item",
  "multi-slider-loop": "Rzl_Ca_multi-slider-loop",
  "multi-slider-section": "Rzl_Ca_multi-slider-section",
  "multi-slider-slide": "Rzl_Ca_multi-slider-slide",
  "multi-slider-wrapper-items": "Rzl_Ca_multi-slider-wrapper-items",
  "scroll": "Rzl_Ca_scroll",
  "slide": "Rzl_Ca_slide",
  "slider": "Rzl_Ca_slider",
  "slider-track": "Rzl_Ca_slider-track",
});
